export default {"src":"/_next/static/media/logo-17.cd4986c9.svg","height":44,"width":57,"blurWidth":0,"blurHeight":0};